module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mdigurp8-c43531b7e32a283f76b5485ed7440e50.jpg";